<template>
    <div class="dml-coupon-details">
        <div v-if="!show" class="dml-coupon-details__title">
            <p class="dml-coupon-details__copy">{{model.valuePrefix}} {{model.valueAmount}}</p>
            <button class="dml-coupon-details__button" v-on:click="handleClick">
                <span v-if="!showContent">Odkryj kod</span>
                <dm-page-preloader v-else class="dml-coupon-details__loader" :isLoading="showContent" :isStatic="true" />
            </button>
        </div>
        <div v-else class="dml-coupon-details__content">
            <dm-coupon-button :code="model.code" v-on:copy="$emit('copy')">
                <div class="dml-coupon-details__description">
                    <p>Twój kod {{model.valueAmount}}: <strong>{{model.code}}</strong></p>
                    <ol class="list">
                        <li class="dml-coupon-details__item">
                            <div>
                                <strong>1. Skopiuj kod</strong> i przejdź do sklepu
                            </div>
                        </li>
                        <li class="dml-coupon-details__item">
                            <div>
                                <strong>2. Dodaj produkty </strong> do koszyka
                            </div>
                        </li>
                        <li class="dml-coupon-details__item">
                            <div>
                                <strong>3. Wpisz kod </strong> podczas składania zamówienia
                            </div>
                        </li>
                    </ol>
                </div>
                <span class="dml-coupon-details__cta _cp"
                   v-on:click="handleRedirect">
                    Kopiuj kod i idź do sklepu
                    <dm-icon name="arrow-right-long" :width="29" :height="16" />
                </span>
            </dm-coupon-button>
        </div>
    </div>
</template>
<script>
    import CouponButtonCompontent from './coupon-button-component.vue';
    import IconComponent from '../shared/icon-component.vue';
    import PagePreloader from '../shared/page-preloader-component.vue';

    export default {
        name: 'dm-coupon-details',
        components: {
            'dm-coupon-button': CouponButtonCompontent,
            'dm-icon': IconComponent,
            'dm-page-preloader': PagePreloader,
        },
        props: {
            url: {
                type: String,
                required: true
            },
            target: {
                type: String,
                required: true
            },
            model: {
                type: Object
            },
            showContent: {
                type: Boolean,
                default: false
            },
            couponContent: {
                type: Object
            }
        },
        computed: {
            show() {
                return Boolean(this.couponContent && this.couponContent.id);
            }
        },
        methods: {
            handleClick() {
                this.$emit('getCoupon');
            },
            handleRedirect() {
                this.$emit('redirectCoupon', this.model.id);
            }
        }
    };
</script>
